<template>
  <div class="upDownControl">
     <el-table
      :data="controlArr"
      style="width: 100%">
      <el-table-column
        prop="startTime"
        label="参数名称"
         align="center"
         width="250"
       >
        <template slot-scope="scope">
          <el-select v-model="scope.row.sensor" placeholder="请选择">
            <el-option
              v-for="item in paramList"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="startTime"
        label="上限"
        align="center"
       >
        <template slot-scope="scope">
          <el-input v-model="scope.row.upperLimit" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="下限"
        align="center"
       >
        <template slot-scope="scope">
          <el-input v-model="scope.row.lowerLimit" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="swiths"
         align="center"
        label="远程控制">
        <template slot-scope="scope">
          <el-checkbox-group v-model="scope.row.swiths">
            <el-checkbox v-for="(item,index) in swiths" :label="item.iotName" :key="index">
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
        </template>
      </el-table-column>

      <el-table-column
        prop="on"
         align="center"
        label="状态">
         <template slot-scope="scope">
           <el-switch
            @change="changeStatus(scope.row)"
            v-model="scope.row.on"
            active-color="#13ce66"
            inactive-color="#f2f2f2">
          </el-switch>

        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="170">
        <template slot-scope="scope">
          <span class="content-delete" @click="handleDelete(scope.$index, scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="add-wrap">
      <div @click="add" class="add">
        <img src="../../../public/images/list_add.png" alt="">
        <span>添加</span>
      </div>
    </div>
    <el-row>
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </el-row>
  </div>
</template>
<script >
import equipmentSocketModule from '../../store/modules/equipmentSocket'
import indexModule from '../../store/modules/index'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'UpDownControl',
  data () {
    return {
      paramList: [],
      controlArr: [
        {
          sensor: '',
          lowerLimit: null,
          upperLimit: null,
          swiths: [],
          on: true
        },
        {
          sensor: '',
          lowerLimit: null,
          upperLimit: null,
          swiths: [],
          on: true
        }
      ]

    }
  },
  watch: {
    async equipmentId () {
      if (this.equipmentId) {
        this.initSwithLimit()
      }
    },
    // 参数下拉列表
    async sensors () {
      this.paramList = this.sensors
      this.initSwithLimit()
    }
  },
  mounted () {
    this.paramList = this.sensors
    if (this.equipmentId) {
      this.initSwithLimit()
    }
  },
  computed: {
    ...mapState(indexModule, ['equipmentId']),
    ...mapState(equipmentSocketModule, ['swiths', 'sensors'])
  },
  methods: {
    ...mapActions(equipmentSocketModule, ['swithUpDownLimit', 'updateSwithUpDownLimit', 'deleteUpDownLimit', 'changeUpDownLimit']),
    // 获取列表数据
    async initSwithLimit () {
      let result = await this.swithUpDownLimit(this.equipmentId)
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          // let a = []
          // result[i].swiths.forEach((f) => {
          //   a.push(f.value)
          // })
          // result[i].swiths = a// 格式化开关['aa','bb']
          result[i].swiths = result[i].swiths.map(m => m.key)
          result[i].lowerLimit = result[i].lowerLimit
          result[i].upperLimit = result[i].upperLimit
          this.paramList.find((f, index) => {
            if (Number(result[i].sensor) === index) {
              result[i].sensor = f.name
            }
          })
        }
        this.controlArr = result
        // console.log('shuj', this.controlArr)
      } else {
        this.controlArr = [
          {
            sensor: '',
            lowerLimit: null,
            upperLimit: null,
            swiths: [],
            on: true
          },
          {
            sensor: '',
            lowerLimit: null,
            upperLimit: null,
            swiths: [],
            on: true
          }
        ]
      }
    },
    // 切换记录状态
    changeStatus (row) {
      // console.log(row)
      if (row.id) {
        this.changeUpDownLimit(row.id).then(() => {
          if (row.on === true) {
            this.$Alert.info({
              content: '开启成功',
              duration: 1000,
              status: 'success'
            })
          } else if (row.on === false) {
            this.$Alert.info({
              content: '关闭成功',
              duration: 1000,
              status: 'success'
            })
          }
        }).catch((err) => {
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
        })
      } else {
        if (row.on === true) {
          this.$Alert.info({
            content: '开启成功',
            duration: 1000,
            status: 'success'
          })
        } else if (row.on === false) {
          this.$Alert.info({
            content: '关闭成功',
            duration: 1000,
            status: 'success'
          })
        }
      }
    },
    handleChecked (index, row) {
      if (row.swiths.length > 0) {
        row.swiths = row.swiths.toString()
      }
    },

    doubleNumber (number) {
      number = number.toString()
      if (number.length === 1) {
        return '0' + number
      } else {
        return number
      }
    },
    // 删除
    handleDelete (index, row) {
      // console.log(row)
      if (row.id) {
        this.$confirm('您确定删除当前选中的记录吗？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // type: 'warning'
          showClose: false
        }).then(async () => {
          this.deleteUpDownLimit(row.id).then(() => {
            this.$Alert.info({
              content: '删除成功',
              duration: 1000,
              status: 'success'
            })
            this.initSwithLimit(index)
          }).catch((err) => {
            this.$Alert.info({
              content: err.response.data,
              duration: 3000,
              status: 'error'
            })
          })
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$confirm('您确定删除当前选中的记录吗？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false
        }).then(async () => {
          this.controlArr.splice(index, 1)
          // this.initSwithLimit(index)
          this.$Alert.info({
            content: '删除成功',
            duration: 1000,
            status: 'success'
          })
        }).catch(err => {
          console.log(err)
          this.$Alert.info({
            content: err.response.data,
            duration: 3000,
            status: 'error'
          })
        })
      }
    },
    add () {
      var obj = {
        sensor: '',
        on: true,
        lowerLimit: null,
        upperLimit: null,
        swiths: []
      }
      this.controlArr.push(obj)
    },
    // 保存
    async save () {
      let saveArr = JSON.parse(JSON.stringify(this.controlArr))
      // saveArr[i].swiths = saveArr[i].swiths.toString()
      let limitReg = /^\d+(\.\d{1,3})?$/ // 上下限
      for (let i = 0; i < saveArr.length; i++) {
        saveArr[i].swiths = saveArr[i].swiths.toString()
        if (saveArr[i].sensor === '') {
          this.$Alert.info({
            content: '请先选择参数名称',
            duration: 3000,
            status: 'error'
          })
          return
        } else if (saveArr[i].upperLimit === null) {
          this.$Alert.info({
            content: '上限不为空',
            duration: 3000,
            status: 'error'
          })
          return
        } else if (saveArr[i].lowerLimit === null) {
          this.$Alert.info({
            content: '下限不为空',
            duration: 3000,
            status: 'error'
          })
          return
        } else if (saveArr[i].swiths.length === 0) {
          this.$Alert.info({
            content: '请至少选择一个开关',
            duration: 3000,
            status: 'error'
          })
          return
        } else if (!limitReg.test(saveArr[i].upperLimit)) {
          this.$Alert.info({
            content: '上限只允许输入数字，最多三位小数点',
            duration: 3000,
            status: 'error'
          })
          return
        } else if (!limitReg.test(saveArr[i].lowerLimit)) {
          this.$Alert.info({
            content: '下限只允许输入数字，最多三位小数点',
            duration: 3000,
            status: 'error'
          })
          return
        } else if (saveArr[i].sensor !== '' && saveArr[i].sensor === '溶解氧') {
          if (saveArr[i].upperLimit > 20 || saveArr[i].upperLimit < 0 || saveArr[i].lowerLimit > 20 || saveArr[i].lowerLimit < 0) {
            this.$Alert.info({
              content: '溶解氧范围：0-20',
              duration: 3000,
              status: 'error'
            })
            return
          }
          if (saveArr[i].upperLimit < saveArr[i].lowerLimit) {
            this.$Alert.info({
              content: '溶解氧范围上限不能小于下限',
              duration: 3000,
              status: 'error'
            })
            return
          }
        } else if (saveArr[i].sensor !== '' && saveArr[i].sensor === '水温') {
          if (saveArr[i].upperLimit > 40 || saveArr[i].upperLimit < 0 || saveArr[i].lowerLimit > 40 || saveArr[i].lowerLimit < 0) {
            this.$Alert.info({
              content: '水温范围：0-40',
              duration: 3000,
              status: 'error'
            })
            return
          }
          if (saveArr[i].upperLimit < saveArr[i].lowerLimit) {
            this.$Alert.info({
              content: '水温范围上限不能小于下限',
              duration: 3000,
              status: 'error'
            })
            return
          }
        } else if (saveArr[i].sensor !== '' && saveArr[i].sensor === 'PH值') {
          if (saveArr[i].upperLimit > 14 || saveArr[i].upperLimit < 0 || saveArr[i].lowerLimit > 14 || saveArr[i].lowerLimit < 0) {
            this.$Alert.info({
              content: 'PH值范围：0-14',
              duration: 3000,
              status: 'error'
            })
            return
          }
          if (saveArr[i].upperLimit < saveArr[i].lowerLimit) {
            this.$Alert.info({
              content: 'PH值范围上限不能小于下限',
              duration: 3000,
              status: 'error'
            })
            return
          }
        } else if (saveArr[i].sensor !== '' && saveArr[i].sensor === '氧化电还原') {
          if (saveArr[i].upperLimit > 999 || saveArr[i].upperLimit < -999 || saveArr[i].lowerLimit > 999 || saveArr[i].lowerLimit < -999) {
            this.$Alert.info({
              content: '氧化电还原范围：-999-999',
              duration: 3000,
              status: 'error'
            })
            return
          }
          if (saveArr[i].upperLimit < saveArr[i].lowerLimit) {
            this.$Alert.info({
              content: '氧化电还原范围上限不能小于下限',
              duration: 3000,
              status: 'error'
            })
            return
          }
        } else if (saveArr[i].sensor !== '') {
          this.paramList.find((f, index) => {
            if (saveArr[i].sensor === f.name) {
              saveArr[i].sensor = index.toString()
            }
          })
        }

        // if (saveArr[i].swiths.length === 0) {
        //   this.$message({
        //     type: 'warning',
        //     message: '请至少选择一个开关!',
        //     duration: 1000
        //   })
        //   return
        // }
        // else {
        //   // let arrvalue = []// 用于存放取出的数组的值
        //   // for (let j = 0; j < saveArr[i].swiths.length; j++) {
        //   //   arrvalue.push(j)// 数组的索引是从0开始的
        //   // }
        //   // saveArr[i].swiths = arrvalue.toString()
        //   saveArr[i].swiths = saveArr[i].swiths.toString()
        // }
      }

      this.updateSwithUpDownLimit({
        id: this.equipmentId,
        saveArr: saveArr
      })
        .then(async () => {
          this.$Alert.info({
            content: '保存成功',
            duration: 1000,
            status: 'success'
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancel () {
      this.initSwithLimit().then(() => {
      })
    }
  }
}
</script>
<style lang="scss">
.upDownControl .el-checkbox {
    margin-left: 10px;
}
//删除框样式
.el-message-box{
  width:340px;
  height:180px;
  background:rgba(32,48,81,1);
  border:1px solid #2886F2;

  .el-message-box__content{
    .el-message-box__message{
      font-size:16px;
      text-align:center;
      font-family:MicrosoftYaHei;
      font-weight:400;
      color:rgba(187,212,233,1);
      margin-top:-10px;
      padding-bottom:20px;
    }
  }
  .el-message-box__btns{
    .el-button--default:first-child{
      width:120px;
      height:40px;
      background:rgba(30,63,117,0);
      border-radius:4px;
    }
    .el-button--primary:last-child{
      width:120px;
      height:40px;
      background:rgba(255,47,47,1);
      border-radius:4px;
      border:1px solid rgba(255,47,47,1);
    }
  }
}
.upDownControl{
  margin-bottom: 20px;
  // .el-table {
  //   color: white;
  //   background: rgba(175,201,255,0.1)!important;
  // }
  // .el-input--prefix .el-input__inner {
  //   padding-left: 30px;
  //   background: none !important;
  //   border: 1px solid #07f;
  //   color: white;
  // }

  .el-radio__label {
    color: #BBD4E9;
  }
  .el-radio__inner {
    border: 1px solid #409EFF;
    background:none;
  }
  .el-checkbox__label {
    color: #BBD4E9;
  }
  .el-checkbox__inner{
    border: 1px solid #409EFF;
    background:none;
  }
  .el-icon-time:before {
    content: "\E642";
    color: #07f;
  }
  .time-control {
    .el-checkbox-group{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      // padding: 0 15px;
    }
    .el-checkbox{
      margin-left: 5px;
    }
    .el-checkbox + .el-checkbox {
      margin-left:5px;
    }
  }
  .add-wrap {
    background: rgba(175, 201, 255, 0.1);
  }

  .add {
    display: inline-block;
    margin-left: 30px;
    line-height: 50px;
    cursor: pointer;

    img {
      width:20px;
      height:20px;
      vertical-align: -5px;
      margin-right: 5px;
    }
    span{
      font-size:14px;
      color:#BBD4E9;
    }
  }

  .el-row {
    margin-top: 20px;
    margin-left: 0;

    .el-button--default {
      background: none !important;
    }
  }
  .el-input {
    position: relative;
    font-size: 14px;
    display: inline-block;
    // width: 220px;

    .el-input__inner {
      border: 1px solid #07f;
      color: #BBD4E9;
      background: none!important;
      //  background: #1E3F75!important;
    }
  }

  .el-input__prefix {
    left: 190px;
  }

  .el-icon-time:before {
    color: #07f;
  }
}

</style>

<style>
.el-table {
  color: white;
  background: rgba(175,201,255,0.1)!important;
}
.el-input--prefix .el-input__inner {
  padding-left: 30px;
  background: none !important;
  border: 1px solid #07f;
  color: white;
}
</style>
